



































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { ChatHelper } from '@signing-page/chat/helpers/chat.helper';
import Avatar from '@/components/Avatar.vue';
import { IComment } from '@signing-page/chat/types/comment';
import { IUser } from '@/types/User';
import { IRecipient } from '@signing-page/documents/types/recipient';

@Component({
  components: { Avatar },
  data: () => ({
    ChatHelper,
  }),
})
export default class ChatComment extends Vue {
  @Prop() comment!: IComment;

  @Prop() me!: string;
  @Prop() user!: IUser;
  @Prop() recipient: IRecipient;
  @Prop() senderName!: string;

  @Prop() isFirstCommentThatDay!: boolean;
  @Prop() isLastComment: boolean;

  @Prop() firstCommentInMonologue: boolean;

  get at(): string {
    return this.$t('at').toString();
  }

  get timestamp(): string {
    return moment(this.comment.createdAt).calendar(null, {
      sameDay: `[${this.$t('today-at').toString()}] LT`,
      lastDay: `[${this.$t('yesterday-at').toString()}] LT`,
      sameElse: `LL [${this.$t('at')}] LT`,
    });
  }

  get isUser(): boolean {
    return this.comment.userId === this.user.id;
  }

  get isMe(): boolean {
    return [this.comment.userId, this.comment.recipientId].includes(this.me);
  }
}
